import { Box, Typography, alpha, useTheme } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";
import { PreviewIcon } from "src/Pages/components/Icons/Icons";

import { DrawerFilterProductionContract } from "./Components/DrawerFilter/DrawerFilterProductionContract";
import { ReportProductionContractPDF } from "./Components/PDF/ReportProductionContractPDF";

export const PageReportProductionContract = () => {
  const { loadingGravar } = useConfigPageContext();
  const { listReportProductionContract } = useContextReportsProduction();
  const theme = useTheme();

  const hasData = !!listReportProductionContract?.data?.length;

  return (
    <>
      <CardHeaderCore
        buttonAdd={[<DrawerFilterProductionContract key="filter" />]}
        icon={<PreviewIcon color="primary" sx={{ fontSize: "20px" }} />}
        sxStyle={{ margin: "1px 0 16px 0", padding: "12px" }}
        subTitle="Gere relatórios detalhados de produção por contrato com filtros personalizados"
        title="Relatório de produção por contrato"
      />

      <ReportProductionContractPDF />

      {!hasData && !loadingGravar && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "50vh",
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
            }}
          >
            <FilterAltOutlinedIcon
              sx={{ fontSize: 28, color: theme.palette.primary.main }}
            />
          </Box>

          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            Nenhum relatório gerado
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ maxWidth: 280, textAlign: "center", lineHeight: 1.6 }}
          >
            Clique em <strong>Filtro</strong> para configurar os parâmetros e
            gerar o relatório.
          </Typography>
        </Box>
      )}
    </>
  );
};
